import React, { useState } from 'react';
import { Upload, Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
import { CreateAllData } from '@/apiError/apiCreate';
import { AntButton } from '@/common/ant-components/AntButton';

const OpeningStockUploadButton = ({ refreshTable }) => {
  const [jsonData, setJsonData] = useState({});

  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e?.target?.result);
      const workbook = XLSX.read(data, { type: 'array' });

      let allSheetsData = {};
      workbook?.SheetNames?.forEach((sheetName) => {
        const sheet = workbook.Sheets[sheetName];
        allSheetsData[sheetName] = XLSX.utils.sheet_to_json(sheet);
      });

      setJsonData(allSheetsData);

      // Trigger the submission after successful upload
      handleSubmit(allSheetsData);
    };

    reader.readAsArrayBuffer(file);
    return false;
  };

  const prepareDataForSubmission = (allSheetsData) => {
    if (!allSheetsData || Object.keys(allSheetsData).length < 3) {
      message.error('Ensure the file has at least three sheets.');
      return null;
    }

    const sheetNames = Object.keys(allSheetsData);
    const openingStockJson = allSheetsData[sheetNames[0]][0] || {}; // Convert array to object
    const itemDetails = allSheetsData[sheetNames[1]];
    const diamondStoneData = allSheetsData[sheetNames[2]];

    let uniqueCounter = 0;

    const structuredData = {
      openingStockJson,
      itemDetails: itemDetails?.map((item) => ({
        ...item,
        codeWindowId: `CW${Date.now().toString(36)}${(uniqueCounter++).toString(36)}`,
        itemCode: null,
        diamondStoneJson: diamondStoneData?.filter(
          (diamond) => diamond?.itemDetailId === item.id,
        ),
      })),
    };

    return structuredData;
  };

  const handleSubmit = async (allSheetsData) => {
    const dataToSend = prepareDataForSubmission(allSheetsData);
    if (!dataToSend) return;

    try {
      await CreateAllData.createItem(
        '/transactions/opening-stocks/import/',
        dataToSend,
      );
      refreshTable();
    } finally {
    }
  };

  return (
    <div>
      <Upload beforeUpload={handleFileUpload} showUploadList={false}>
        <AntButton icon={<UploadOutlined />}>Upload Opening Stock</AntButton>
      </Upload>
    </div>
  );
};

export default OpeningStockUploadButton;
